import client from '../../client';

const BUYER_ALERTS = {
  getCorrespondingProperties(buyerAlertId) {
    return client.get(`/buyer_alerts/${buyerAlertId}/corresponding_properties`)
  },
}

export default BUYER_ALERTS;
